<div class="row student-row">
  <!--this is student local video div   -->
  <div class="student-grid" *ngIf="localUser?.accessType === AccessType.STUDENT">
    <div class="student-block wrtc-subscriber-div d-flex flex-column wrtc-publisher-div">
      <!--      TODO - implement-->
      <!--      [ngClass]="{'student-video-mute': !currentParticipantInfo.video.isProvided}"-->
      <div id="wrtc-publisher" class="wrtc-subscriber wrtc-publisher" #mediaWrapper></div>
      <div class="videoColorCircle"
           *ngIf="whiteboard | isSharedWith:localUser.id"
           [ngStyle]="{'background-color': localUser.personalColor}"
      ></div>

      <div class="wrtc-subscriber-label-div d-flex align-items-center"
        [ngClass]="(gameMode.isStarted && gameMode.participantsTeamIndexById[localUser.id] !== undefined  ?
        'team-color-index_' + gameMode.teams[gameMode.participantsTeamIndexById[localUser.id]].colorIndex :
        '')"
      >

        <!--        TODO - implement [ngClass]="currentParticipantInfo.audio.levelClass"-->

        <div class="volumebar-wrap d-flex mr-2" [ngClass]="'vol-' + (currentParticipantVoiceMeterValue)"
          title="Voice meter">
          <div class="volume-strip strip-1"></div>
          <div class="volume-strip strip-2"></div>
          <div class="volume-strip strip-3"></div>
          <div class="volume-strip strip-4"></div>
          <div class="volume-strip strip-5"></div>
        </div>

        <div class='wrtc-subscriber-label text-truncate wrtc-publisher-label'>{{localUser.displayName}}</div>
      </div>

      <!--TODO: ???????????-->
      <!--            <div id="wrtc-publisher-volumeBar" class="wrtc-publisher-volumeBar"></div>-->

      <div class="wrtc-subscriber-controls d-flex flex-column">
        <span ngbTooltip="Muting is no longer available for this lesson"
              tooltipClass="mute-self-audio-tooltip"
              triggers="click focus"
              [disableTooltip]="!(localUser.audio.selfMuteAttemptsCount >= 2 && !localUser.audio.isMuted)"
              placement="bottom-right">
            <button class="video-action-btn wrtc-publisher-muted-icon"
                    [disabled]="localUser.audio.selfMuteAttemptsCount >= 2 && !localUser.audio.isMuted"
                    title="{{ !room.isClassroomMuted ? 'Microphone on/off' : 'The class is in Quiet mode. Unmuting is not allowed' }}"
                    (click)="toggleMuteSelfAudio()"
                    [ngClass]="{'active': localUser?.audio.isMuted || !localUser?.audio.isProvided}"
                    [ngStyle]="{'cursor': localUser?.audio.isProvided && !room.isClassroomMuted  ? 'pointer': 'default'}">
            <i class="fas fa-microphone" [ngClass]="{'fa-microphone-slash': localUser?.audio.isMuted || !localUser?.audio.isProvided}"></i>
          </button>
        </span>
      </div>

      <!--star container -->
      <div class="star-container d-flex">
        <span *ngFor="let sticker of localUser.stickers"
              class="sticker-icon" [ngClass]="'sticker-' + sticker">
          <img alt="{{'Sticker ' + sticker}}"
               [ngClass]="'sticker-' + sticker" title="{{sticker}}"
               [src]="'assets/img/stickers/12x12/' + sticker + '-icon.png'">
        </span>
      </div>
    </div>
  </div>

  <!--  TODO - review hidden condition -->
  <div class="student-grid" *ngFor="let student of usersListService.videoSectionUsers; let i = index"
       [hidden]="
          student.additionalInfo.roomConnectionStatus === RoomConnectionState.OFFLINE && !student.additionalInfo.isClassParticipant ||
          localUser.accessType === AccessType.STUDENT && gameMode.isStarted && gameMode.isTeamTalkOn &&
          gameMode.participantsTeamIndexById[localUser.id] !== gameMode.participantsTeamIndexById[student.id] ||
          localUser.accessType === AccessType.STUDENT && student.additionalInfo.roomConnectionStatus !== RoomConnectionState.ONLINE
       ">

    <ng-container>
      <app-remote-student class="student-block wrtc-subscriber-div"
        [ngClass]="{
          'absent-student': student.additionalInfo.roomConnectionStatus === RoomConnectionState.OFFLINE && student.additionalInfo.isClassParticipant && (
          localUser.accessType === AccessType.SUPPORT || localUser.accessType === AccessType.TEACHER || localUser.accessType === AccessType.OBSERVER),
          'dominant-speaker':  student.additionalInfo.isDominantSpeaker && !student.additionalInfo.audio.isMuted,
          'unread-message': student.additionalInfo.hasUnansweredMessage
        }"
        [student]="student"
        [status]="student?.additionalInfo.roomConnectionStatus"
        [studentsCount]="usersListService.videoSectionUsers.length"
        [userIndex]="i">
      </app-remote-student>
    </ng-container>
  </div>

  <!--this is remoteUsers students -->
</div>
